import {
  type AxiosCompatibleResponse,
  type RequestConfig,
} from '../http/types';

import { type CMSLocales } from './types';

import {
  BRAND_PAGE_BY_SLUG_ENDPOINT,
  CONTENTFUL_ENDPOINT,
} from '@/constants/endpoints';
import { isProduction } from '@/modules/env/isProduction';
import { typedHttp } from '@/modules/http';
import { replacePathParams } from '@/modules/http/replacePathParams';

export function getBrandPageBySlug(slug: string, locale: CMSLocales) {
  return typedHttp.get(
    replacePathParams(BRAND_PAGE_BY_SLUG_ENDPOINT, { slug }),
    {
      params: { locale },
      cache: 'force-cache',
    }
  );
}

export function getContentfulData<TData = unknown>({
  query,
  cache,
  revalidate = 900,
}: {
  query: string;
  revalidate?: number;
  cache?: RequestConfig['cache'];
}) {
  return typedHttp.post(
    CONTENTFUL_ENDPOINT,
    { query },
    {
      revalidate: isProduction() ? revalidate : 0,
      cache,
    }
  ) as Promise<AxiosCompatibleResponse<TData>>;
}
